import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["outsourceContainer", "consultantContainer", "submitBtn", "errors"]
  static values = { updateUrl: String }

  addCard(event) {
    const role = event.currentTarget.dataset.role
    const container = role === "outsource_partners"
      ? this.outsourceContainerTarget
      : this.consultantContainerTarget

    // Clone the first card as template
    const firstCard = container.querySelector("[data-controller*='team-card']")
    if (firstCard) {
      const clone = firstCard.cloneNode(true)
      // Clear inputs and chips in the clone
      clone.querySelectorAll("input").forEach(input => { input.value = "" })
      clone.querySelectorAll("[data-team-card-target='memberChips']").forEach(el => { el.innerHTML = "" })
      // Remove initial-* attributes so the cloned card starts empty
      delete clone.dataset.teamCardInitialCompanyIdValue
      delete clone.dataset.teamCardInitialCompanyNameValue
      delete clone.dataset.teamCardInitialMembersValue
      // Hide the "Add Members" button
      const addBtn = clone.querySelector("[data-team-card-target='addMembersBtn']")
      if (addBtn) { addBtn.classList.add("hidden"); addBtn.classList.remove("inline-flex") }
      container.appendChild(clone)
    }
  }

  async save() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this._hideErrors()
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Saving..."

    try {
      const outsourcePartners = this._collectCards(this.outsourceContainerTarget)
      const reConsultants = this._collectCards(this.consultantContainerTarget)
      const ownerMembers = this._collectOwnerMembers()

      const response = await fetch(this.updateUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          outsource_partners: outsourcePartners,
          re_consultants: reConsultants,
          owner_members: ownerMembers
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        this._showErrors(data.errors || ["Update failed"])
        this.submitBtnTarget.disabled = false
        this.submitBtnTarget.textContent = "Save Changes"
      }
    } catch {
      this._showErrors(["A network error occurred. Please try again."])
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Save Changes"
    }
  }

  _showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.innerHTML = messages.map(m => `<p>${m}</p>`).join("")
    this.errorsTarget.classList.remove("hidden")
  }

  _hideErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("hidden")
    this.errorsTarget.innerHTML = ""
  }

  _collectOwnerMembers() {
    const ownerEl = this.element.querySelector("[data-controller*='owner-members']")
    if (!ownerEl) return []
    const chips = ownerEl.querySelectorAll("[data-chip-email]")
    return Array.from(chips).map(c => c.dataset.chipEmail).filter(Boolean)
  }

  _collectCards(container) {
    const cards = container.querySelectorAll("[data-controller*='team-card']")
    const result = []

    cards.forEach(card => {
      const companyHidden = card.querySelector("[data-team-card-target='companyHidden']")
      const companyId = companyHidden?.value
      if (!companyId) return

      const chips = card.querySelectorAll("[data-team-card-target='memberChips'] [data-chip-email]")
      const members = Array.from(chips).map(chip => chip.dataset.chipEmail).filter(Boolean)

      result.push({ company_id: companyId, members })
    })

    return result
  }
}
